import script from "./AppRadioButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppRadioButton.vue?vue&type=script&setup=true&lang=ts"

import "./AppRadioButton.vue?vue&type=style&index=0&id=8fa15fda&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fa15fda"]])

export default __exports__